/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
	auth: {
		authority: "https://login.microsoftonline.com/ef0bfcbe-c119-4d21-9f0d-852d459b516c",
		clientId: process.env.REACT_APP_AZURE_AD_CLIENTID,
		redirectUri: process.env.REACT_APP_AZURE_AD_REDIRECTURI
	},
	cache: {
		cacheLocation: "localStorage", // This configures where your cache will be stored
		storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
	},
	system: {
		loggerOptions: {
			loggerCallback: (level, message, containsPii) => {
				if (containsPii) {
					return;
				}
				switch (level) {
					case LogLevel.Error:
						console.error(message); return;
					case LogLevel.Info:
						console.info(message); return;
					case LogLevel.Verbose:
						console.debug(message); return;
					case LogLevel.Warning:
						console.warn(message); return;
				}
			}
		}
	}
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
	// Could possibly use just the ClientID, but have to use something.
	// api://clientIdGuid/ScopeName
	// "api://462521e0-3481-4c49-ac81-9feda60cbf20/DockingSolutionsJobTracker"
	// "api://d360bfe0-00b9-4dcd-8ec2-1447859fe733/JobTracker"
	scopes: [ process.env.REACT_APP_AZURE_AD_SCOPE ]
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
// export const graphConfig = {
//     graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
// };
